import React from 'react';
import { useMutation } from '@apollo/client';
import { Modal } from '..';
import { REMOVE_TEAM_MEMBER } from '../../graphql/mutations/teamMember';
import RemoveMemberWrapper from './removeMember.style';
import { onRemoveTeamMemberHandler } from './handler';

const RemoveMember = (props) => {
  const {
    isShow,
    onCancel,
    teamName,
    userName,
    teamId,
    user,
    refetchMemberList,
  } = props;

  const [removeTeamMember, { loading: isLoadingRemove }] =
    useMutation(REMOVE_TEAM_MEMBER);

  const onRemoveMember = () => {
    onRemoveTeamMemberHandler({
      removeTeamMember,
      teamId,
      userId: user?.id,
      onCancel,
      refetchMemberList,
    });
  };

  return (
    <RemoveMemberWrapper>
      <Modal
        isShow={isShow}
        title="Remove User"
        okText="Remove"
        okDanger
        width={458}
        onCancel={onCancel}
        onOk={onRemoveMember}
        isLoadingButton={isLoadingRemove}
      >
        {isShow && (
          <div className="font-paragraph component_modal_remove_member_text">
            Are you sure want to remove&nbsp;
            <b>{userName}</b>
            &nbsp;from&nbsp;
            <b>{teamName}</b>
          </div>
        )}
      </Modal>
    </RemoveMemberWrapper>
  );
};

export default RemoveMember;
